import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadScans (options) {
    const params = {
      limit: options.limit ? options.limit : 500,
      offset: 0,
      is_archived: false,
      timeframe: options.timeframe,
      campaign: options.campaign.id
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/dashboard/scans/', { params }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadSummary (options) {
    const params = {
      timeframe: options.timeframe,
      campaign: options.campaign.id
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/dashboard/summary/', { params }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async downloadScan (options) {
    const params = {
      campaign: options.campaign,
      timeframe: options.timeframe
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('dashboard/scans/csv/', { params, responseType: 'blob' }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
